import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class LuckyCauldronBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.LUCKY_CAULDRON;
}

export default LuckyCauldronBuildingTileEntity;
